<template>
  <div class="policy-page">
    <!-- 顶部标题栏 -->
    <div class="page-header">
      <div class="header-back" v-if="isViewMode" @click="goBack">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <h1 class="page-title">📋 条款和政策</h1>
    </div>

    <!-- 内容区域 -->
    <div class="content-container">
      <article class="policy-article">
        <section>
          <h2 class="article-title">移动应用 - 使用条款</h2>
          <p class="update-date">最新修订日期：2018 年11月15日</p>

          <p>
            下载，安装和使用【我的安视优®PLUS】移动应用程序（"<b>【我的安视优®PLUS】</b>"），构成您接受和承认以下使用条款（"<b>条款</b>"），此处条款可由强生视力健商贸（上海）有限公司（"<b>强生</b>"）随时修订，且是眼科护理专业人士和强生公司之间关于【我的安视优®PLUS】的使用的约束性协议。
          </p>

          <h3>1. 强生政策</h3>
          <p>
            条款的补充和整合：<b>"强生政策"</b>，包括使用 [www.acuvue.com.cn]（<b>"安视优网站"</b>）的条款（包括但不限于强生隐私政策）。了解隐私政策可登陆：
            <a href="#/policy_new">https://plus.51i.cc/policy_new</a>
          </p>

          <h3>2. 用户许可</h3>
          <p>
            根据条款，强生授予眼科护理专业人士非排他的、不可转让的、有限的和可撤销的使用【我的安视优®PLUS】的许可，但须在由眼科护理专业人士拥有或控制符合此处条款（"<b>用户许可</b>"）的设备上（<b>每个"设备"</b>）为商业用途使用。禁止以其他方式使用【我的安视优®PLUS】，包括但不限于，转售、转让、修改或分销与【我的安视优®PLUS】关联的应用程序或文本、图片、音乐、条形码、视频、数据、超链接、显示器和其它内容（"<b>内容</b>"）。本协议及用户许可适用于【我的安视优®PLUS】的任何更新或补充或更换，除非这些更新、补充或替代有单独适用的条款。
          </p>

          <h3>3. 保密</h3>
          <p>
            3.1 为达到【我的安视优®PLUS】的用途，强生可能以书面、口头和/或其他方式向眼科护理专业人士披露某些信息。强生向眼科护理专业人士披露的此类信息不限于：新产品、商业计划、数据、专有技术、配方工艺、设计、草图、照片、计划、图纸、材料规格、产品规格、样品、财务信息、报告、研究、发现、发明、创意、客户名单、客户的个人信息、价格信息、价格协议、设定和其他任何信息。所有此类被披露的信息都是机密的（"<b>保密信息</b>"）。
          </p>
          <p>3.2 眼科护理专业人士同意对收到的强生保密信息保密，不向任何第三方披露或非为【我的安视优®PLUS】需要的其他目的使用保密信息。</p>
          <p>3.3 眼科护理专业人士根据此处条款获得的所有包含保密信息，和其他有形的保密材料的书面和电子文件都是强生公司的财产。</p>
          <p>3.4 眼科护理专业人士承认并同意是按"现状"为基础接受的信息，即对其准确性、完整性或其他方面无任何明示、暗示或其他方式担保。</p>

          <h3>4. 用户信息</h3>
          <p>
            访问"我的安视优®PLUS"，您需要提供一定的信息（包括以下定义的个人信息）以创建账户。您知晓并同意强生各公司及分支机构（"<b>强生公司</b>"）就经营和推广强生产品及服务、强生公司内部管理、强生产品及服务的数据分析和统计等目的（"<b>目的</b>"），收集、分享、处理、储存和使用您的个人信息。
          </p>
          <p>您知晓并同意，为实现上述目的，强生可能与代表强生公司履行职能的代理商、经销商和/或服务提供商分享您的个人信息。</p>
          <p>您注册为会员即表示同意并授权强生公司及受托公司通过信件、电子邮件和/或通过包括社交网络平台在内的其他数据形式的方式向您主动发送强生产品及服务相关推广、营销、知识教育信息或向您发起呼叫。</p>

          <h3>5. 可接受的使用</h3>
          <p>【我的安视优®PLUS】和任何通过【我的安视优®PLUS】连接传输的内容、信息及保密信息仅限于设定功能的使用。</p>

          <h3>21. 适用法律和管辖权</h3>
          <p>此处条款适用中国的法律，不考虑法律冲突规则。因使用【我的安视优®PLUS】或此处条款产生或涉及的任何法律行动，眼科护理专业人士不可撤销地同意中国法院的专属管辖权。</p>

          <h3>24. 联系强生公司</h3>
          <p>如有任何关于【我的安视优®PLUS】的疑问、投诉可直接联系服务您的强生公司销售经理。</p>
          <p>电话：400-882-3636</p>
          <p>邮件：support@acuvue.com.cn</p>
        </section>
      </article>
    </div>

    <!-- 底部操作栏 -->
    <div class="action-bar" v-if="!isViewMode">
      <div class="action-btn cancel-btn" @click="close">
        <span>取消</span>
      </div>
      <div class="action-btn accept-btn" @click="go_sms">
        <span>接受并继续</span>
      </div>
    </div>
    <!-- 查看模式底部 -->
    <div class="action-bar" v-else>
      <div class="action-btn accept-btn" style="flex: 1;" @click="goBack">
        <span>返回</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'policy',
  data() {
    return {
      isViewMode: false
    }
  },
  mounted() {
    // 检查是否是查看模式
    this.isViewMode = this.getQueryString('view') === 'true'
  },
  methods: {
    getQueryString(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      )
    },
    goBack() {
      this.$router.go(-1)
    },
    close() {
      document.addEventListener('WeixinJSBridgeReady', function() {
        WeixinJSBridge.call('closeWindow')
      }, false)
      WeixinJSBridge.call('closeWindow')
    },
    go_sms() {
      // 存储同意状态
      localStorage.setItem('policyAgreed', 'true')
      
      const link = this.getQueryString('link')
      if (link) {
        this.$router.push({ path: `/?link=${link}&policy_if=y` })
      } else {
        this.$router.push({ path: '/?policy_if=y' })
      }
    }
  }
}
</script>

<style scoped>
.policy-page {
  height: 100vh;
  height: -webkit-fill-available;
  display: flex;
  flex-direction: column;
  background: #f5f7fa;
  padding-top: env(safe-area-inset-top);
  padding-top: constant(safe-area-inset-top);
  overflow: hidden;
}

/* 顶部标题栏 */
.page-header {
  background: linear-gradient(135deg, #d51900 0%, #b01500 50%, #8a1000 100%);
  padding: 50px 20px 30px;
  text-align: center;
  flex-shrink: 0;
  position: relative;
}

.header-back {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
}

.header-back svg {
  width: 24px;
  height: 24px;
}

.page-title {
  font-size: 22px;
  font-weight: 800;
  color: #ffffff;
  margin: 0;
  letter-spacing: 2px;
}

/* 内容区域 */
.content-container {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 16px;
  padding-bottom: 20px;
}

.policy-article {
  background: #ffffff;
  border-radius: 16px;
  padding: 24px 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

.article-title {
  font-size: 20px;
  font-weight: 700;
  color: #1a2a3a;
  margin: 0 0 8px;
  text-align: center;
}

.update-date {
  font-size: 12px;
  color: #8a9aaa;
  text-align: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e8eef3;
}

.policy-article h3 {
  font-size: 16px;
  font-weight: 700;
  color: #d51900;
  margin: 24px 0 12px;
  padding-left: 12px;
  border-left: 3px solid #d51900;
}

.policy-article p {
  font-size: 14px;
  color: #5a6a7a;
  line-height: 1.8;
  margin-bottom: 12px;
  text-align: justify;
}

.policy-article b {
  color: #1a2a3a;
}

.policy-article a {
  color: #d51900;
  text-decoration: none;
}

/* 底部操作栏 */
.action-bar {
  flex-shrink: 0;
  display: flex;
  gap: 12px;
  padding: 16px;
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
  padding-bottom: calc(16px + constant(safe-area-inset-bottom));
  background: #ffffff;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08);
}

.action-btn {
  flex: 1;
  height: 50px;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.cancel-btn {
  background: #f8f8f8;
  color: #666;
  border: 1px solid #e8e8e8;
}

.cancel-btn:active {
  background: #eee;
}

.accept-btn {
  background: linear-gradient(135deg, #d51900 0%, #ff3b2f 100%);
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(213, 25, 0, 0.3);
}

.accept-btn:active {
  transform: scale(0.98);
}

/* iOS safe area 兼容 */
@supports (padding-top: constant(safe-area-inset-top)) {
  .policy-page {
    padding-top: constant(safe-area-inset-top);
  }
  .action-bar {
    padding-bottom: calc(16px + constant(safe-area-inset-bottom));
  }
}
</style>



// WEBPACK FOOTER //
// src/views/policy.vue